export interface HistoryDto<T> {
  history: T[];

  total: number;
}

export interface ValidatorError {
  /**
   * 错误类型
   */
  type: string;
  /**
   * 错误字段
   */
  loc: string[];
  /**
   * 错误信息
   */
  msg: string;
  /**
   * 原始值
   */
  input: unknown;
}

export interface HttpErroBody<T = unknown> {
  detail: T;
}

export const languages = [
  '英语',
  '日语',
  '韩语',
  '葡萄牙语',
  '俄语',
  '西班牙语',
  '法语',
  '意大利语',
  '荷兰语',
  '波兰语',
  '德语',
] as const;

export type Language = (typeof languages)[number];

export const pseudoModels = new Map([
  ['app_video_translate', '视频翻译'],
  ['app_video_smart_erase', '智能擦除'],
  ['app_video_quality_restoration', '画质修复'],
]);
